import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Index from "./page/index";
import GameUid from "./page/game-uid";
import TopupIdPass from "./page/topup-id-pass";
import CardTopup from "./page/card-topup";
import PaymentGame from "./page/payment_game";
import PaymentMobile from "./page/payment_mobile";
import PolicyPrivacy from "./page/policy_privacy";
import Cart from "./page/cart";
import Login from "./page/login";
import Register from "./page/register";

import Notfound from "./page/notfound";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Index />} />
    <Route path="/game-uid" element={<GameUid />} />
    <Route path="/topup-id-pass" element={<TopupIdPass />} />
    <Route path="/card-topup" element={<CardTopup />} />
    <Route path="/payment-game" element={<PaymentGame />} />
    <Route path="/payment-mobile" element={<PaymentMobile />} />
    <Route path="/cart" element={<Cart />} />
    <Route path="/policy-privacy" element={<PolicyPrivacy />} />
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />

    <Route path="/*" element={<Notfound />} />
  </Routes>
);

export default AppRoutes;
